<script>
import { merchantComputed } from "@store/helpers";
import TheMixin from "../mixin/main";

export default {
  components: {
    ToolReservation: () => import("@components/Tool/ToolReservation"),
  },
  mixins: [ TheMixin ],
  computed: {
    ...merchantComputed,
    isShowToolReservation() {
      const hiddenRouteList = [
        'reservation',
        'reservation-item',
        'reservation-checkout',
        'reservation-unpaid-checkout',
        'reservation-checkout-detail',
        'prepaid-reservation',
        'prepaid-checkout',
        'prepaid-checkout-detail',
      ];

      return !hiddenRouteList.includes(this.$route.name)
    },
  },
}
</script>
<!-- section template -->
<template>
  <div :class="$style.layout">
    <TheHeader v-if="isShowHeader"/>
    <slot/>
    <TheFooter v-if="isShowFooter"/>
    <ToolReservation
      v-if="isShowToolReservation && isSiteEnabled"
      :title="currentMerchant.cosmeticSetting.title || '線上預約'"
    />
  </div>
</template>
<!-- section style -->
<style lang="scss" module>
.layout {
  :global {
    .layout {
      @include unstyled;
    }
  }
}
</style>
